const RELATIONSHIP = [
  { value: 'Patient', text: 'Patient' },
  { value: 'Carer', text: 'Carer' },
  { value: 'HP', text: 'Healthcare Professional' }
];

type RELATIONSHIP = typeof RELATIONSHIP;

export default RELATIONSHIP;
